import * as Yup from 'yup';

export const recoveryValidation = Yup.object().shape({
  email: Yup.string()
    .email('Must be a valid email')
    .max(255)
    .required('Email is required'),
});

export const recoveryInitial = {
    email: '',
    submit: null,
}